import ClientOrder from './modules/ClientOrderVuex'

export default {
  ClientOrder,
}

